import type { ReactNode } from 'react';
import { PageHeader } from '../../templates/page/page';

export interface DataToolsViewProps {
	scopeSelector: ReactNode;
	demoData: ReactNode;
	additionalTools?: ReactNode;
}

export function DataToolsView({ scopeSelector, demoData, additionalTools }: DataToolsViewProps) {
	return (
		<div>
			<PageHeader size="display" title="Dati" />
			{scopeSelector}
			<div className="space-y-6">
				{demoData}
				{additionalTools}
			</div>
		</div>
	);
}
